module.exports = __webpack_public_path__ + "img/swiss-travel-association.33cb30f.png";